var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 100,
    viewBox: "0 0 119 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5988 0.00446186C65.0199 -0.234621 72.4576 9.19314 81.6187 14.1662C92.6796 20.1707 107.358 21.3017 113.775 32.1283C120.571 43.5932 120.342 58.7363 115.367 71.1006C110.54 83.0959 99.5611 91.7649 87.7033 96.9202C77.3279 101.431 65.8531 98.676 54.5988 97.5202C44.627 96.4961 34.9289 95.3243 26.0915 90.5928C16.0645 85.2244 4.33112 79.647 0.939069 68.7909C-2.44702 57.9539 4.02364 46.7051 9.22526 36.6131C13.7101 27.9116 20.8463 21.5326 28.465 15.3857C36.5291 8.87929 44.2399 0.242119 54.5988 0.00446186Z",
    fill: "#FF602E",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8334 58.3745C63.3667 58.3745 62.1116 57.8518 61.068 56.8065C60.0227 55.763 59.5 54.5078 59.5 53.0412V39.7078C59.5 38.2412 60.0227 36.9861 61.068 35.9425C62.1116 34.8972 63.3667 34.3745 64.8334 34.3745H70.1667C71.6334 34.3745 72.8894 34.8972 73.9347 35.9425C74.9783 36.9861 75.5 38.2412 75.5 39.7078V53.0412C75.5 54.5078 74.9783 55.763 73.9347 56.8065C72.8894 57.8518 71.6334 58.3745 70.1667 58.3745H64.8334ZM64.8334 53.0412H70.1667V39.7078H64.8334V53.0412ZM52.8334 71.7078C51.6334 71.7078 50.5667 71.3638 49.6334 70.6758C48.7 69.9861 48.0556 69.0634 47.7 67.9078L40.8334 45.0412V34.3745H46.1667V45.0412L52.8334 66.3745H75.5V71.7078H52.8334ZM48.8334 79.7078V74.3745H75.5V79.7078H48.8334Z",
    fill: "#FF602E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountTwo);
export default __webpack_public_path__ + "static/media/count-two.c433bb5f974d7846eb98149eac4e9164.svg";
export { ForwardRef as ReactComponent };